import React, {useContext, useEffect} from 'react';
import {useNavigate} from "react-router";
import {userGetByEmail} from "../requests/User";
import {Auth} from "@aws-amplify/auth";
import {AppContext} from "../libs/ContextLibs";

export default function Home(props) {
    const {isUserNameOverride, userNameOverride} = useContext(AppContext);
    const navigate = useNavigate();

    useEffect(() => {
        const onLoad = async () => {
            let user = await Auth.currentUserInfo();
            userGetByEmail((isUserNameOverride && userNameOverride) ? userNameOverride : user?.username, (response) => {
                if (response && response.default_chart !== null && response.default_chart.length > 0) {
                    navigate('/dashboard/' + response.default_chart);
                }
            });
        };
        onLoad();
    }, [navigate]);

    return (

        <>
        </>
    );
}
